import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/**
 * LlmThread but only what the client needs.
 */

const llmThreadLiteSchema_ = z.object({
  _id: zExt.objectId(),
  agentName: z.string(),
  team: zExt.objectId(),
  createdAt: z.date(),
  updatedAt: z.date(),
});
export const llmThreadLiteSchema: z.ZodType<LlmThreadLite> =
  llmThreadLiteSchema_;
export interface LlmThreadLite extends z.infer<typeof llmThreadLiteSchema_> {}
